interface PillToggleOption<T extends string> {
  id: T;
  label: string;
}

interface PillToggleProps<T extends string> {
  options: readonly PillToggleOption<T>[];
  active: T;
  onChange: (id: T) => void;
}

export function PillToggle<T extends string>({
  options,
  active,
  onChange,
}: PillToggleProps<T>) {
  return (
    <div className="flex w-full gap-3 rounded-[36px] bg-[var(--bg-tab-track)] p-1">
      {options.map((option) => {
        const selected = option.id === active;
        return (
          <button
            key={option.id}
            type="button"
            aria-pressed={selected}
            onClick={() => onChange(option.id)}
            className={`flex-1 rounded-[36px] px-6 py-2 text-base font-semibold transition-colors ${
              selected
                ? "bg-[var(--accent-tab-active)] text-white"
                : "text-[var(--text-muted)] hover:text-white"
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
